import { useState, type FC } from 'react'

import { Drawer } from '@/components'

import { useCategories } from '@/helpers/query/use-categories'
import { useDocuments } from '@/helpers/query/use-documents'
import { Categories } from './components/categories'
import { CategoryInner } from './components/category-inner'

import { useDocumentContent } from '@/helpers/query/use-document-content'
import { Document } from './components/document'

interface T_DocumentsDrawerProps {
  hideDocumentsDrawer: () => void
}

type T_StepName = 'category' | 'category-inner' | 'document'

export type T_NavItem = {
  name: T_StepName
  title: string
  categoryId?: string
  docName?: string 
}

export const DocumentsDrawer: FC<T_DocumentsDrawerProps> = ({
  hideDocumentsDrawer,
}) => {
  const [ stack, setStack ] = useState<T_NavItem[]>([
    { name: 'category', title: 'Документы' },
  ])

  const current = stack[stack.length - 1]
  const push = (item: T_NavItem) => setStack((s) => [ ...s, item ])
  const pop = () => setStack((s) => (s.length > 1 ? s.slice(0, -1) : s))
  const previous = stack.length > 1 ? stack[stack.length - 2] : null
  const backTitle = previous?.title

  const categoryId = current.categoryId ?? ''
  const title = current.title
  const docName = current.docName  

  const handleBack = () => {
    if (stack.length > 1) pop()
    else hideDocumentsDrawer()
  }

  // Get categories
  const { data: cats, isLoading: isLoadingCats } = useCategories()
  // Get children
  const { data: docs, isLoading: isLoadingSubcats } = useDocuments(categoryId)
  // Get document content
  const { data: currentDoc, isLoading: isLoadingDoc } = useDocumentContent(categoryId, docName)
  
  return (
    <Drawer
      backTitle={current.name === 'category' || current.name === 'category-inner' ? 'Документы' : backTitle}
      onClose={handleBack}
      isBackdropClosable
      withHeaderCard
      isFullScreen
    >
      {current.name === 'category' && <Categories cats={cats} isLoading={isLoadingCats} push={push} />}
      {current.name === 'category-inner' && 
      <CategoryInner
        current={current}
        categoryId={categoryId}
        cats={cats}
        docs={docs}
        isLoading={isLoadingSubcats}
        onSetStack={setStack}
        stack={stack}
        push={push}
      />}
      {current.name === 'document'   && 
      <Document 
        title={title} 
        currentDoc={currentDoc?.[0]} 
        isLoading={isLoadingDoc} 
      />}
    </Drawer>
  )
}
